var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"fab-container",attrs:{"column":""}},_vm._l((_vm.items),function(item){return _c('whiteboard-menu-speed-dial',_vm._g({key:item.name,attrs:{"item":item}},_vm.getActions(item)))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }